import xAxisModelParser from './component/xAxis';
import barModelParser from './series/bar';
import dvScatterModelParser from './series/dvScatter';
import dvMarkerModelParser from './series/dvMarkerSeries';

export default [barModelParser, xAxisModelParser, dvScatterModelParser, dvMarkerModelParser];
